@if (is_active) {
  <div class="navigation__tab__content_single" [ngClass]="{'active': is_active}">
    <ng-content></ng-content>
  </div>
}
